// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"pq-z","slideIn":"qq-z"};